import { FaCloud, FaLightbulb, FaBrain } from "react-icons/fa6";
import images from "./images";

const About = {
    sub: "About Us",
    heading: "Pioneering AI for Your Success",
    description: "At CoreAI, we are transforming the way businesses operate with cutting-edge AI technologies. Our mission is to simplify processes, enhance productivity, and empower growth.",
    points: [
        { icon: <FaCloud />, title: "Scalable Cloud", content: "Leverage our secure cloud platforms to meet your growing business needs." },
        { icon: <FaLightbulb />, title: "Innovative AI", content: "Stay ahead with our AI tools designed to tackle complex challenges." }
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        src3: images.about3,
        src4: images.about4,
        alt1: "About Image 1",
        alt2: "About Image 2",
        alt3: "About Image 3",
        alt4: "About Image 4",
        experience: {
            years: "30+ years",
            title: "of AI Expertise",
            icon: <FaBrain />
        }
    },
    button: {
        text: "Learn More",
        link: "Services"
    }
};

export default About;